"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'recordings';
exports.SET_ALL_RECORDINGS = exports.namespace + "/SET_ALL_RECORDINGS";
exports.REMOVE_RECORDING = exports.namespace + "/REMOVE_RECORDING";
exports.SET_RECORDING_SETTINGS = exports.namespace + "/SET_RECORDING_SETTINGS";
exports.SET_PLANNER_SORTING = exports.namespace + "/SET_PLANNER_SORTING";
exports.FETCH_SCHEDULED_RECORDINGS = exports.namespace + "/FETCH_SCHEDULED_RECORDINGS";
exports.FETCH_RECORDING_SLOTS_BY_IDS = exports.namespace + "/FETCH_RECORDING_SLOTS_BY_IDS";
exports.SET_SCHEDULED_RECORDING_SET = exports.namespace + "/SET_SCHEDULED_RECORDING_SET";
exports.RECORD_PROGRAMME = exports.namespace + "/RECORD_PROGRAMME";
exports.CANCEL_RECORD_PROGRAMME = exports.namespace + "/CANCEL_RECORD_PROGRAMME";
exports.RECORD_SERIES_LINK = exports.namespace + "/RECORD_SERIES_LINK";
exports.CANCEL_RECORD_SERIES_LINK = exports.namespace + "/CANCEL_RECORD_SERIES_LINK";
exports.RESET_RECORD_PROGRAMME = exports.namespace + "/RESET_RECORD_PROGRAMME";
exports.RESET_RECORD_SERIES_LINK = exports.namespace + "/RESET_RECORD_SERIES_LINK";
exports.MIGRATE_RECORDINGS = exports.namespace + "/MIGRATE_RECORDINGS";
exports.SET_MIGRATION_COMPLETED = exports.namespace + "/SET_MIGRATION_COMPLETED";
//# sourceMappingURL=constants.js.map